/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var OnlineTrainingStatus;

(function (OnlineTrainingStatus) {
  OnlineTrainingStatus["TO_BE_SCHEDULED"] = "to_be_scheduled";
  OnlineTrainingStatus["BOOKED"] = "booked";
  OnlineTrainingStatus["CONFIRMED"] = "confirmed";
  OnlineTrainingStatus["COMPLETED"] = "completed";
  OnlineTrainingStatus["NO_SHOW"] = "no_show";
  OnlineTrainingStatus["RESCHEDULED"] = "rescheduled";
  OnlineTrainingStatus["CANCELLED_BY_BROKER"] = "cancelled_by_broker";
  OnlineTrainingStatus["CANCELLED_INTERNALLY"] = "cancelled_internally";
})(OnlineTrainingStatus || (OnlineTrainingStatus = {}));